import React, { useMemo } from 'react'

import { Column, Row } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

import Addresses from './Addresses'
import Bottom from './Bottom'
import GetInTouch from './GetInTouch'
import QuickLinks from './QuickLinks'
import { Container, Content } from './styles'
import Top from './Top'

type Props = {
  secondary?: boolean
}

function Footer({ secondary }: Props) {
  const { isMobile, isWideDesktop } = useResponsiveLayout()

  const content = useMemo(() => {
    if (secondary) {
      if (isMobile) {
        return (
          <Column gap={10}>
            <Top secondary />
            <Addresses secondary />
            <GetInTouch />
          </Column>
        )
      }

      return (
        <Row alignCenter fullWidth gap={10} spaceBetween>
          <Column gap={10}>
            <Top secondary />
            <Addresses secondary />
          </Column>

          <GetInTouch />
        </Row>
      )
    }

    if (isWideDesktop) {
      return (
        <Row alignStart fullWidth spaceBetween>
          <Top />
          <QuickLinks />
          <Addresses />
          <GetInTouch />
        </Row>
      )
    }

    if (isMobile) {
      return (
        <Column alignCenter gap={8}>
          <Top />
          <Row fullWidth gap={10} spaceBetween>
            <QuickLinks />
            <Addresses />
          </Row>
          <GetInTouch />
        </Column>
      )
    }

    return (
      <Column alignCenter fullWidth gap={10}>
        <Top />
        <Row fullWidth gap={10} spaceBetween>
          <QuickLinks />
          <Addresses />
          <GetInTouch />
        </Row>
      </Column>
    )
  }, [isMobile, isWideDesktop, secondary])

  return (
    <Container px={[5, 5, 5, 5, 100]} py={[52, 52, 52, 52, 100]}>
      <Content
        alignItems={['center', 'center', 'center', 'center', 'flex-start']}
      >
        {content}

        <Bottom />
      </Content>
    </Container>
  )
}

export default Footer
